import { OnlyPostSignUpConfig } from "../interfaces/PrivateConfig";
import { OnlyPreSignUpConfig } from "../interfaces/PublicConfig";
import {
  PostSignUpConfig,
  PreSignUpConfig,
  TSwitchFromPostSignUpState,
  TSwitchFromPreSignUpState,
} from "../storage/store";
import { _forEach, _includes } from "./referralLodash";

export function splitSwitchesFromPostSignUp(postSignUp: PostSignUpConfig) {
  const _postSignUpSwitches: Array<keyof TSwitchFromPostSignUpState> = [
    "isJuspayEnabled",
    "rabu",
    "isBonusExpiryEnabled",
    "isCsatNewFlowEnabled",
    "isExoCacheEnabled",
    "isNewReferralScreenFlowEnabled",
    "isPlotLineSDKEnabled",
    "isNewHelpdeskFlowEnabled",
    "isVoiceNoteSupportEnabled",
    "isEnableXSupportEnabled",
  ];
  const _otherData: Partial<OnlyPostSignUpConfig> = {};
  const _switchPostSignUpData: Partial<TSwitchFromPostSignUpState> = {};
  _forEach(postSignUp, (value: any, key: any) => {
    if (_includes(_postSignUpSwitches, key)) {
      _switchPostSignUpData[key as keyof TSwitchFromPostSignUpState] = value;
    } else {
      _otherData[key as keyof OnlyPostSignUpConfig] = value;
    }
  });
  return { _otherData, _switchPostSignUpData };
}

export function splitSwitchesFromPreSignUp(preSignUp: PreSignUpConfig) {
  const _preSignUpSwitches: Array<keyof TSwitchFromPreSignUpState> = [
    "isPwfEnabled",
    "isNewRelicEnabled",
    "isSocialEnabled",
    "isNewSignupFlowEnabled",
    "isHealthJobEnabled",
    "isHealthEventsEnabled",
    "isSocketMonitoringEnabled",
    "isSocketRecordMetricEnabled",
    "isSocketHttpOkClientEnabled",
    "isExoCacheEnabled",
    "isQuickRejoin",
    "isGPSyncOnConnect",
    "socketReconnectionBackoffEnabled",
    "socketReconnectionPeriodInSeconds",
    "socketReconnectionBackoff",
    "preSignUpConnectTimeout",
    "preSignUpReadTimeout",
    "keepAlive",
    "isPrefilledAmountEnabledOnDeposit",
    "isWebFlowForReferralEnabled",
    "newHomeScreen",
    "isNewReferralScreenFlowEnabled",
    "isGRLBEnabled",
    "isJuspayEnabled",
    "isReferAndEarnEnabled",
    "howToPlayEnabled",
  ];
  const _otherData: OnlyPreSignUpConfig = {};
  const _switchPreSignUpData: TSwitchFromPreSignUpState = {};
  _forEach(preSignUp, (value: any, key: any) => {
    if (_includes(_preSignUpSwitches, key)) {
      _switchPreSignUpData[key as keyof TSwitchFromPreSignUpState] = value;
    } else {
      _otherData[key as keyof OnlyPreSignUpConfig] = value;
    }
  });
  return { _otherData, _switchPreSignUpData };
}
